import { DetailsLegacyLinkPropsType, DetailsLinkPropsType } from '../../types';

export const isLegacyLinkProps = (
  props: DetailsLinkPropsType | DetailsLegacyLinkPropsType
): props is DetailsLegacyLinkPropsType => 'href' in props;
